import { render, staticRenderFns } from "./BatteryMeter.vue?vue&type=template&id=0bb8283c&scoped=true"
import script from "./BatteryMeter.vue?vue&type=script&lang=js"
export * from "./BatteryMeter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bb8283c",
  null
  
)

export default component.exports